export default (list = []) => {
  let dataTree = [];
  for (let i = 0; i < list.length; i++) {
    const privilegeA = list[i];
    let foundParent = false;
    for (let j = 0; j < list.length; j++) {
      const privilegeB = list[j];
      if (privilegeA.parent_id === privilegeB.resource_id) {
        foundParent = true;
        const repeated = Array.isArray(privilegeB.children) ? privilegeB.children.find((v) => {
          return v.resource_id === privilegeA.resource_id;
        }) : false;

        if (!repeated) {
          if (privilegeB.children) {
            privilegeB.children.push(privilegeA);
          } else {
            privilegeB.children = [privilegeA];
          }
        }
      }
    }
    if (!foundParent) {
      dataTree.push(privilegeA);
    }
  }
  return dataTree;
};
